
import type { PropType } from 'vue'
import type { EpbLoadingBackgroundStyle, EpbLoadingMode } from './epb-loading.types'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbLoading',
  props: {
    backgroundStyle: {
      type: String as PropType<EpbLoadingBackgroundStyle>,
      default: 'opaque',
    },
    mode: {
      type: String as PropType<EpbLoadingMode>,
      default: 'fixed',
    },
  },
  setup() {
    const baseClass = 'epb-loading'
    return {
      baseClass,
    }
  },
})
